import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/CountryBlockedPage.css';

const CountryBlockedPage = ({ userIp, userCountry, userCountryName }) => {
    const { t } = useTranslation();

    return (
        <div className="country-blocked-page">
            <div className="blocked-container">
                <div className="blocked-left">
                    <img
                        src="/assets/geoblocked.png"
                        alt="Geo Blocked"
                        className="blocked-image"
                        onError={(e) => {
                            // Fallback если картинка не найдена
                            e.target.style.display = 'none';
                            e.target.nextElementSibling.style.display = 'block';
                        }}
                    />
                    <div className="blocked-icon-fallback" style={{ display: 'none' }}>
                        <svg width="200" height="200" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" stroke="#ff4757" strokeWidth="2" />
                            <path d="m15 9-6 6" stroke="#ff4757" strokeWidth="2" />
                            <path d="M9 9l6 6" stroke="#ff4757" strokeWidth="2" />
                        </svg>
                    </div>
                </div>

                <div className="blocked-right">
                    <h1 className="blocked-title">
                        {t('countryBlocked.title', 'Доступ ограничен')}
                    </h1>

                    <p className="blocked-text">
                        {t('countryBlocked.message', 'К сожалению, наш сервис недоступен в вашей стране.')}
                    </p>

                    <div className="blocked-details">
                        {userCountryName && (
                            <div className="detail-item">
                                <span className="detail-label">
                                    {t('countryBlocked.detectedCountry', 'Обнаружена страна:')}
                                </span>
                                <span className="detail-value">{userCountryName}</span>
                            </div>
                        )}

                        {userIp && (
                            <div className="detail-item">
                                <span className="detail-label">
                                    {t('countryBlocked.yourIp', 'Ваш IP-адрес:')}
                                </span>
                                <span className="detail-value">{userIp}</span>
                            </div>
                        )}
                    </div>




                </div>
            </div>
        </div>
    );
};

export default CountryBlockedPage; 